/**
 * 门店相关类型定义（对齐 api-contract.md StoreDTO）
 */

import { PageRequest, PageData } from '../../common';

// 门店格式枚举（值域对齐后端 StoreFormat：FRESH/SUPERMARKET/HYPER）
export enum StoreFormat {
  FRESH = 'GF',
  SUPERMARKET = 'SUPER',
  HYPER = 'HYPER',
}

// 门店状态枚举
export enum StoreStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

// 门店信息（对齐 StoreDTO）
export interface Store {
  id: number;
  storeCode: string;                    // 门店编码（业务唯一标识）
  storeName: string;                    // 门店名称（泰语）
  englishName: string | null;           // 英文名称
  state: string | null;                 // 所在省份
  city: string | null;                  // 所在城市
  address: string | null;               // 详细地址
  area: number | null;                  // 门店面积（平方米）
  storeFormat: StoreFormat;             // 门店格式
  status: StoreStatus;                  // 门店状态
  creatorAccount: string;
  creatorName: string;
  gmtCreate: number;
  modifierAccount: string;
  modifierName: string;
  gmtModified: number;
}

// 门店列表查询请求（对齐 StoreQueryRequest）
export interface PageStoreRequest extends PageRequest {
  storeCode?: string;                   // 门店编码（模糊查询）
  storeName?: string;                   // 门店名称（模糊查询）
  storeFormat?: StoreFormat;            // 门店格式
  status?: StoreStatus;                 // 门店状态
  state?: string;                       // 省份
  city?: string;                        // 城市
}

// 门店列表响应
export type PageStoreData = PageData<Store>;
